<template>
    <div class="project-selector">
        <div class="dropdown">
            <a href="#" v-dropdown data-bs-popper-config='{"strategy":"fixed"}' aria-haspopup="true" aria-expanded="false" class="project">
                <span class="stage-marker">{{stageCode}}</span>
                <img v-if="project.client && project.client.logo" :src="project.client.logo" alt="">
                <div class="project-selector-text">
                    <h2>{{ project.title }}</h2>
                    <p class="client">{{ project.client ? project.client.company : '' }}</p>
                </div>
            </a>

            <div class="dropdown-menu">
                <router-link tag="a" class="dropdown-item" :to="{ name: 'projects.show.details', params: { 'project_id': project.id }}">
                    Overall Project
                </router-link>
                <router-link :key="stage.id" v-for="stage in project.stages"  tag="a" class="dropdown-item" :to="{ name: stageRouteName(stage), params: { project_id: project.id, sprint_id: 'active', stage_id: stage.id }}">
                    {{stage.stage.name}}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        project: {
            type: Object
        },
        stage: {
            type: Object
        }
    },
    computed: {
        stageCode () {
            if (this.stage) {
                switch (this.stage.stage_id) {
                    case 1:
                        return 'D'
                        break;
                    case 2:
                        return 'DR'
                        break;
                    case 3:
                        return 'DEV'
                        break;
                }
            }

        }
    },
    methods: {
        stageRouteName: function(stage) {
            return 'projects.stage'+stage.stage.id+'.overview'
        }
    }
}

</script>
